import React from 'react'
import { Link } from 'react-router-dom'


const Error404 = () => {
    return (
        <>
            <div className="error-page d-flex align-items-center justify-content-center">
                <div className="error-container text-center p-4">
                    <h1 className="error-code mb-2">404</h1>
                    <h2 className="display-6 error-message mb-3 mt-5">Page non trouvée</h2>
                    <p className="lead error-message mb-5">Nous ne parvenons pas à trouver la page que vous recherchez.</p>
                    <div className='buttons'>
                        <Link to={'/'} className="btn  btn-danger text-white ">
                        <i className="fa-solid fa-house"></i> Retour à l'Accueil
                        </Link>
                        <Link to={`https://wa.me/2250788898998?text=Bonjour Elk-Tech Groupe, est-ce qu'il serait possible de discuter avec quelqu'un au sujet du logiciel Pressing 360? `} className="btn  btn-outline-dark" style={{ 'border' : '0.5px solid black' }} >
                            <i className="fa-brands fa-whatsapp"></i> Parler à un commercial
                        </Link>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Error404